export interface CategoryMaskIconProps {
  /** Absolute URL of the uploaded SVG (Vercel Blob). */
  url: string
  /** Hex tint. When undefined/null the icon inherits `currentColor`. */
  color?: string | null
  size?: number
  className?: string
}

/**
 * Renders an uploaded SVG as a single-colour silhouette via CSS mask: the
 * box is filled with `backgroundColor` and clipped to the SVG's alpha shape,
 * so the SVG's own colours are ignored (matches the CMS help-text contract).
 * No inline <svg> path → not flagged by `lint:icons`.
 *
 * A blank colour is a valid editor choice meaning "inherit currentColor", so
 * it falls back to `currentColor` — NOT `undefined`. `background-color` does
 * not inherit and its initial value is `transparent`, so an unset background
 * would clip the mask to nothing and render an empty (invisible) box.
 */
export function CategoryMaskIcon({
  url,
  color,
  size = 32,
  className,
}: CategoryMaskIconProps) {
  return (
    <span
      aria-hidden
      className={className}
      style={{
        display: "inline-block",
        width: size,
        height: size,
        backgroundColor: color || "currentColor",
        maskImage: `url("${url}")`,
        WebkitMaskImage: `url("${url}")`,
        maskRepeat: "no-repeat",
        WebkitMaskRepeat: "no-repeat",
        maskPosition: "center",
        WebkitMaskPosition: "center",
        maskSize: "contain",
        WebkitMaskSize: "contain",
      }}
    />
  )
}
